// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"762":"bd7956a78428a671","785":"85a36c6a612aa029","795":"7584fe12e3e316b8"}[chunkId] + ".js";
};